import SocialFeedWidget from './SocialFeedWidget';

export default SocialFeedWidget;
